/* eslint-disable import/prefer-default-export */

/**
 * Converts a hex value and opactiy to an rgba value
 * @function
 * @param {string} hex - Color in hexidecimal format - e.g. #89ea7c
 * @param {number} a - (Alpha) Opacity expressed as value < 1 - e.g. 0.6
 * @return {string} rgba string - e.g rgba(137, 234, 124, 0.6)
 */
function transparentize(hex, a) {
  const match = hex.match(
    /^#(?=(?:.{3}|.{6})$)([a-f0-9]{1,2})([a-f0-9]{1,2})([a-f0-9]{1,2})$/i
  )

  /*
    Regex Explainer:
    ^#    Match start of string
    (?=(?:.{3}|.{6})$) Match only if rest of string is 3 or 6 characters
    ([a-f0-9]{1,2}) capture 1 to 2 characters, in range a-f or 0-9 (x3)
  */

  if (!match) {
    throw new Error(`${hex} is not a valid hex value`)
  }

  const [r, g, b] = match.slice(1)
    .map(n => `${n}${n.length === 1 ? n : ''}`)
    .map(n => parseInt(n, 16))

  return `rgba(${[r, g, b, a].join(', ')})`
}

export {
  transparentize,
}
